import {Directive, ElementRef, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Results} from '../../../core/results';
import {WithdrawReason} from './withdraw-reason';
import {WithdrawReasonsService} from '../withdraw-reasons.service';
declare var $: any;
@Directive({
  selector: '[appWithdrawReason]',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => WithdrawReasonDirective),
    multi: true
  }]
})
export class WithdrawReasonDirective implements ControlValueAccessor, OnInit {

  @Input() private withdrawReason: WithdrawReason;
  @Input() private disabled = false;
  select2: any;

  constructor(private el: ElementRef, private service: WithdrawReasonsService) {
  }

  ngOnInit(): void {
    const that = this;
    this.select2 = $(this.el.nativeElement).select2({
      width: '100%',
      placeholder: 'Cancel reason',
      allowClear: true,
      ajax: {
        transport: function(params, success, failure) {
          const page = 1;
          const perPage = 10;

          that.service.search(page, perPage, 'ASC', 'name', params.data.term).subscribe((ret: Results<WithdrawReason>) => {
            success(ret);
          });

        },
        dataType: 'json',
        type: 'GET',
        processResults: function(data) {
          const arr = [];
          data.content.forEach(function(obj) {
            arr.push({
              id: JSON.stringify(obj),
              text: obj.name,
            });
          });
          return {
            results: arr
          };
        }
      }
    });
    $(this.el.nativeElement).on('select2:select', function(e) {

      that.withdrawReason = JSON.parse(e.params.data.id);
      that.propagateChange(that.withdrawReason);

    });

    $(this.el.nativeElement).on('select2:unselect', function(e) {

      that.withdrawReason = null;
      that.propagateChange(that.withdrawReason);
    });


  }

  onTouched = () => {
  };

  propagateChange = (_: any) => {
  };

  writeValue(withdrawReason: WithdrawReason): void {

    this.withdrawReason = withdrawReason;
    this.propagateChange(this.withdrawReason);
    const that = this;
    if (this.withdrawReason !== undefined && this.withdrawReason !== null) {
      const option = new Option(withdrawReason.name, JSON.stringify(withdrawReason), true, true);
      that.select2.append(option);
      that.select2.trigger('change');
    }

  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  get value(): any {
    return this.withdrawReason;
  }

  set value(v: any) {
    if (v !== this.withdrawReason) {
      this.withdrawReason = v;
      this.propagateChange(v);
    }
  }


}
